<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        align-self="center"
        class="text-center"
        cols="12"
        sm="8"
        md="6"
        lg="4"
        offset-sm="2"
        offset-md="3"
        offset-lg="4"
      >
        <v-img
          src="../../assets/image3.png"
          width="100%"
          max-width="400px"
          class="mx-auto mb-10"
        />
        <p class="text-h5 font-weight-bold">
          {{ $t('forbiddenSpaceTitle') }}
        </p>
        <p class="text-body-1">
          {{ $t('forbiddenSpaceText') }}
        </p>
        <v-btn
          data-testid="redirect-button"
          color="accent"
          large
          class="rounded-xxl text-none mt-10 px-4"
          @click="redirectToMySpaces"
        >
          {{ $t('forbiddenBtnRedirectToMySpaces') }}
        </v-btn>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
export default {
    methods: {
        redirectToMySpaces(){
            window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/spaces"
        }
    },
}
</script>


